class HatNotFound extends HTMLElement {
    connectedCallback() {
    this.innerHTML = `
            <style>
                .container {
                    max-width: 480px;
                    margin: 80px auto;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;
                }
                .code {
                    font-size: 72px;
                    font-weight: 700;
                    color: #d1d5db;
                    line-height: 1;
                }
                .title {
                    font-size: 22px;
                    font-weight: 600;
                    color: #1f2937;
                }
                .message {
                    font-size: 15px;
                    color: #6b7280;
                }
            </style>
            <div class="container">
                <div class="code">404</div>
                <div class="title">Link not found</div>
                <div class="message">This share link doesn't exist or may have been removed.</div>
            </div>
        `;
    }
}

customElements.define('hat-not-found', HatNotFound);